import { render, staticRenderFns } from "./TaskResultDataCompare.vue?vue&type=template&id=1aaf34fc&scoped=true"
import script from "./TaskResultDataCompare.vue?vue&type=script&lang=js"
export * from "./TaskResultDataCompare.vue?vue&type=script&lang=js"
import style0 from "./TaskResultDataCompare.vue?vue&type=style&index=0&id=1aaf34fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf34fc",
  null
  
)

export default component.exports